import { useEffect } from 'react';
import { usePrevious, usePrefersReducedMotion } from '.';
import { useRouteTransition } from 'hooks';

function useScrollRestore() {
  const { status } = useRouteTransition();
  const prevStatus = usePrevious(status);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    const hasEntered = prevStatus === 'entering' && status === 'entered';
    const hasEnteredReducedMotion = prefersReducedMotion && status === 'entered';

    if (hasEntered || hasEnteredReducedMotion) {
      // Only scroll to top for new routes, not back/forward navigation
      // Let browser handle scroll restoration for bfcache compatibility
      if (window.history.state?.scrollRestore !== false) {
        window.scrollTo(0, 0);
      }

      // Focus main content for accessibility
      const mainContent = document.getElementById('MainContent');
      if (mainContent) {
        mainContent.focus();
      }
    }
  }, [prefersReducedMotion, prevStatus, status]);
}

export default useScrollRestore;
